import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import { useState, useEffect, useContext } from 'react';
import ItemCounter from "./ItemCount";
import { CartContext } from "../context/CartContext";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import PulseLoader from "react-spinners/PulseLoader";
//import cerrar from "../../assets/cerrar.png";

const override = {
    margin: "0px auto",
};
const ItemDetail = ({ productos, idd }) => {

    console.log("productos",productos)

    const { nombre, precio, ingredientes,img } = productos;
    const [loading, setLoading] = useState(true);

    const { addItem } = useContext(CartContext);

    const onAdd = (cantidad) => {
        if (cantidad !== undefined) {
            addItem(productos, cantidad, idd);

            toast.success("Has agregado " + cantidad + " " + nombre + " al carrito", {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
            });

        } else {
            toast.error("Acurrio un problema con su pedido")
        }
    }
    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 2000);
    })
let signoPeso = "$"
    return (
        <div>
            <div className="item-detail-container" >
                <div className="img-detail-container">
                    <Link to="/" className="link-ajuste3">
                        <img src="/img/cerrar.png" alt="" className="cerrar" />
                    </Link>
                    <div className="img-detail" style={{backgroundImage: `url(${img})`}}></div>
                </div>
                <div className="info-producto">
                    <div className="info-producto-2">
                        <div className="info-nombre-ingredientes">
                            <h2 className="nombre-detail">{nombre}</h2>
                            <p className="ingredientes-detail">{ingredientes}</p>
                        </div>
                        <span className="precio-detail">{signoPeso}{precio}</span>
                    </div>
                    <ItemCounter inicial={1} onAdd={onAdd} precioo={precio} />
                </div>

            </div>
        </div>
    )
}
//onAdd={onAdd} stock={stock} border-radius: 2rem 2rem 0 0; src={productos.img}
export default ItemDetail